import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { currencyOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Organization } from 'src/app/models/um/organization';
import { DatePipe } from '@angular/common'
import { CommonService } from '../../../services/common.service';
import { UserService } from 'src/app/services/user.service';
import { DateObject, Document_Upload_File } from 'src/app/models/common';
import * as $ from 'jquery';
import { Clipboard } from '@angular/cdk/clipboard';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-um-organization-view-modal',
  templateUrl: './um-organization-view-modal.component.html',
  styleUrls: ['./um-organization-view-modal.component.scss']
})
export class UmOrganizationViewModalComponent implements OnInit {
  @Input() public Content: any;
  formFields;
  operations;
  isView = false;
  viewId = null;
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  TimeZoneList:any
  baseU: string;
  currencyOptions = currencyOptionsConstant;
  document_attach_list: Document_Upload_File[] = [];
  document_delete_list: Document_Upload_File[] = [];
  dsdocument_attach_list: Document_Upload_File[] = [];
  dsdocument_delete_list: Document_Upload_File[] = [];
  istCurrlist: any[];
  eapCurrlist: any[];
  cmeCurrlist: any[];
  charityCurrlist: any[];
  sponsorCurrlist: any[];
  accemaillist: any[];
  crremaillist: any[];
  content: any;
  heading: string;
  disabledDates: Date[] = [];
  action: Subject<any> = new Subject();
  usertype: string;
  organization: Organization;
  orgForm: UntypedFormGroup;
  user: string;
  orgname: string;
  username: string = 'sample username';
  password: string = '';
  email: string;
  isSuperAdmin: boolean;
  isUploadClick: boolean = false;
  isDeleteClick: boolean = false;
  url: any = '';
  UserCnt: string;
  minDate:Date;
  maxDate: Date = new Date();
  LicenseEndDate: Date;
  ISCHARITYData: boolean = false;
  ISSPONSERSHIPData: boolean = false;
  ISCMEData: boolean = false;
  displayNames: any[];
  CME_Module: boolean = false;
  CHARITY_Module: boolean = false;
  SPONSERSHIP_Module: boolean = false;

  userSelctedTimeZone:string;
  analyticsDefaultControlsData :any;
  constructor(
    private userService: UserService,
    public modalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    public commonService: CommonService,
    private commonservice: CommonService,
    public datepipe: DatePipe,
    public Clipboard: Clipboard
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
   // this.disabledDates = this.createDisabledDates();
  }

  ngOnInit() {
    this.minDate  = new Date() ;
    this.getTimeZones();
    this.username = this.userService.getUserName();
    this.usertype = this.userService.getUserType();
    this.email = this.userService.getUserDetais().EMAIL;
    this.baseU = serviceConstants.baseUrl;
    if (this.userService.getUserDetais().USER_TYPE === "A") {
      this.isSuperAdmin = true;
      this.user = "superadmin@scimaxglobal.com";
    }
    else
      this.isSuperAdmin = false;
    this.organization = new Organization();
    this.organization.AUTHTYPE = "MED";
    this.organization.CODE = "";
    this.organization.IS_ANALYTICS_CONFIGURED = false;

    //this.organization.LICENCE_END_DATE = null
    this.setForm(this.organization);
    this.GetDefaultControlsData();
    this.orgForm.get("EAP")?.disable();
    this.orgForm.get("CME")?.disable();
    this.orgForm.get("CHARITY")?.disable();
    this.orgForm.get("SPONSERSHIP")?.disable();
    this.orgForm.controls["IST_DISPLAY_NAME"]?.disable();
    this.orgForm.controls["GRANTS_DISPLAY_NAME"]?.disable();
    this.orgForm.controls["CME_DISPLAY_NAME"]?.disable();
    this.orgForm.controls["EAP_DISPLAY_NAME"]?.disable();
    this.orgForm.controls["CHARITY_DISPLAY_NAME"]?.disable();
    this.orgForm.controls["SPONSERSHIP_DISPLAY_NAME"]?.disable();

    if (this.Content.heading == "Add") this.disableAnalyticscontrols();
    
    if (this.Content.content && this.Content.content.id) { // Edit mode
      this.summaryService.getSummaryData('api/organization/getorganizationbyid/' + this.Content.content.id).subscribe((result) => {
        this.organization = result;
        this.LicenseEndDate = new Date(this.organization.LICENCE_END_DATE?.toString().replace('Z', ''));
        this.UserCnt = result.UserCnt;
        this.ISCHARITYData = result.ISCHARITYData;
        this.ISSPONSERSHIPData = result.ISSPONSERSHIPData;
        this.ISCMEData = result.ISCMEData;
        this.setForm(this.organization);
        this.getMasterData();
        this.orgForm.controls["CODE"].disable();
        this.orgForm.controls["NAME"].disable();

        if(this.Content.heading === 'Edit'){
          if(this.organization.IS_ANALYTICS_CONFIGURED == false){
            this.disableAnalyticscontrols();
          }
          this.orgForm.get("EAP_DISPLAY_NAME")?.disable();
        }

        if(this.organization.LOGI_CLIENTID == null){
          this.orgForm.patchValue({
            LOGI_URL: this.analyticsDefaultControlsData.LogiComposerURL,
            LOGI_CLIENTID: this.analyticsDefaultControlsData.ClientID,
            LOGI_CLIENT_SECRET: this.analyticsDefaultControlsData.ClientSecret,
            LOGI_SUPERVISOR_USERNAME: this.analyticsDefaultControlsData.Username,
            LOGI_SUPERVISOR_PASSWORD: this.analyticsDefaultControlsData.Password,
          });
        }

        if((this.Content.heading === 'View' || this.Content.heading === 'Edit') && this.isSuperAdmin == true) {
          if(this.organization.CANREFRESH == true && this.organization.IS_ORG_ACCOUNT_IN_LOGI == false && this.organization.IS_ANALYTICS_CONFIGURED == true){
            this.commonservice.ValidationBanner("The analytics account is not created for the organization '"+ this.organization.NAME + "'. Please refresh the details to create an account");
          } 
         }

        if (this.Content.heading === 'View')
          setTimeout(() => {
            this.orgForm.disable({ emitEvent: false });
          }, 100);
         
      });
    }
    else {

    }
  }

//   createDisabledDates():  Array<Date> {
// debugger
//     let dates = [];
//     let today = new Date();
//     today.setHours(0, 0, 0, 0); // Reset time to start of the day
//     let i = new Date(1900, 0, 1);
//     for (let d = i ; d < today; d.setDate(d.getDate() + 1)) {
//       dates.push(new Date(d));
//     }
//     // for (let d = new Date(); d <= today; d.setDate(d.getDate() - 1)) {
//     //   dates.push(new Date(d));
//     // }
//     return dates;
//   }

  disableAnalyticscontrols() {
    this.orgForm.get("LOGI_URL")?.disable();
    this.orgForm.get("LOGI_CLIENTID")?.disable();
    this.orgForm.get("LOGI_CLIENT_SECRET")?.disable();
    this.orgForm.get("LOGI_SUPERVISOR_USERNAME")?.disable();
    this.orgForm.get("LOGI_SUPERVISOR_PASSWORD")?.disable();
  }

  enableAnalyticscontrols() {
    this.orgForm.get("LOGI_URL")?.enable();
    this.orgForm.get("LOGI_CLIENTID")?.enable();
    this.orgForm.get("LOGI_CLIENT_SECRET")?.enable();
    this.orgForm.get("LOGI_SUPERVISOR_USERNAME")?.enable();
    this.orgForm.get("LOGI_SUPERVISOR_PASSWORD")?.enable();
  }

  GetDefaultControlsData() {
    if (this.Content.heading != "View") {
      this.summaryService.GetMasterScreenData("api/organization/GetOrgAnlyticsInfo").subscribe(result => {
        if (result != null && result != undefined) {
          this.analyticsDefaultControlsData = result;
          this.orgForm.patchValue({
            LOGI_URL: result.LogiComposerURL,
            LOGI_CLIENTID: result.ClientID,
            LOGI_CLIENT_SECRET: result.ClientSecret,
            LOGI_SUPERVISOR_USERNAME: result.Username,
            LOGI_SUPERVISOR_PASSWORD: result.Password,
            LOGI_ADMIN_USERNAME: result.AdminUsername,
            LOGI_ADMIN_PASSWORD: result.AdminPassword,
            LOGI_ADMIN_ACCESSTOKEN: result.AccessToken,
          });
        }
      })
    }
  }

  EnableAnalytics(event) {
    if (event.target.checked) {
      this.enableAnalyticscontrols();
    } else {
      this.disableAnalyticscontrols();
    }
  }

  getTimeZones()
  {
    this.userService.fetchTimeZones().subscribe(result =>
      {
        this.TimeZoneList = result;
      }     
    )
  }
  getMasterData() {
    this.summaryService.GetMasterScreenData('api/organization/GetMasterScreenData/' + this.Content.content.id).subscribe(summary => {
      this.accemaillist=  [{label:"Select",value:"", checked: true}].concat(summary["MasterData1"]);
      this.crremaillist=[{label:"Select",value:"", checked: true}].concat(summary["MasterData2"]);
      //this.crremaillist = summary["MasterData2"];
      this.istCurrlist = summary["MasterData3"];
      this.eapCurrlist = summary["MasterData4"];
      this.cmeCurrlist = summary["MasterData5"];
      this.charityCurrlist = summary["MasterData6"];
      this.sponsorCurrlist = summary["MasterData7"];
    });
    
    //this.crremaillist=  [{label:"Select",value:"", checked: true}].concat(this.crremaillist);

      if (this.organization.IST && this.organization.IST_CURRENCY_ID == null)
      {
        this.orgForm.controls["IST_CURRENCY_ID"].setValue(this.organization.DEFAULT_CURRENCY_ID);
      }
        if(this.organization.EAP && this.organization.EAP_CURRENCY_ID == null)
        {
          this.orgForm.controls["EAP_CURRENCY_ID"].setValue(this.organization.DEFAULT_CURRENCY_ID);
        }
        // if(this.organization.GRANTS)
        // {
        //   if(this.organization.CME_CURRENCY_ID == null){
        // this.orgForm.controls["CME_CURRENCY_ID"].setValue(this.organization.DEFAULT_CURRENCY_ID);}
        // if(this.organization.CHARITABLE_CURRENCY_ID == null){
        // this.orgForm.controls["CHARITABLE_CURRENCY_ID"].setValue(this.organization.DEFAULT_CURRENCY_ID);}
        // if(this.organization.SPONSERSHIP_CURRENCY_ID == null){
        // this.orgForm.controls["SPONSERSHIP_CURRENCY_ID"].setValue(this.organization.DEFAULT_CURRENCY_ID);}
        // }
        if (this.organization.GRANTS) {
          if (this.organization.CME) {
            if (this.organization.CME_CURRENCY_ID == null) {
              this.orgForm.controls["CME_CURRENCY_ID"].setValue(
                this.organization.DEFAULT_CURRENCY_ID
              );
          if (this.organization.IST && this.organization.IST_CURRENCY_ID == null)
          {
            this.orgForm.controls["IST_CURRENCY_ID"].setValue(this.organization.DEFAULT_CURRENCY_ID);
          }
            if(this.organization.EAP && this.organization.EAP_CURRENCY_ID == null)
            {
              this.orgForm.controls["EAP_CURRENCY_ID"].setValue(this.organization.DEFAULT_CURRENCY_ID);
            }
            if(this.organization.GRANTS)
            {
              if(this.organization.CME_CURRENCY_ID == null){
            this.orgForm.controls["CME_CURRENCY_ID"].setValue(this.organization.DEFAULT_CURRENCY_ID);}
            if(this.organization.CHARITABLE_CURRENCY_ID == null){
            this.orgForm.controls["CHARITABLE_CURRENCY_ID"].setValue(this.organization.DEFAULT_CURRENCY_ID);}
            if(this.organization.SPONSERSHIP_CURRENCY_ID == null){
            this.orgForm.controls["SPONSERSHIP_CURRENCY_ID"].setValue(this.organization.DEFAULT_CURRENCY_ID);}
            }
          }
          if (this.organization.CHARITY) {
            if (this.organization.CHARITABLE_CURRENCY_ID == null) {
              this.orgForm.controls["CHARITABLE_CURRENCY_ID"].setValue(
                this.organization.DEFAULT_CURRENCY_ID
              );
            }
          }
          if (this.organization.SPONSERSHIP) {
            if (this.organization.SPONSERSHIP_CURRENCY_ID == null) {
              this.orgForm.controls["SPONSERSHIP_CURRENCY_ID"].setValue(
                this.organization.DEFAULT_CURRENCY_ID
              );
            }
          }
        }
      }
  }

  myDate = new Date();
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate() - 1;
  documaent_attach_list: Document_Upload_File[] = [];
  // ss: IMyDate = {
  //   year: this.year,
  //   month: this.moth,
  //   day: this.Day
  // }
  // DatePickerGlobalOptions = {
  //   dateFormat: 'dd-mmm-yyyy',
  //   minYear: new Date().getFullYear(),
  //   disableUntil: this.ss,
  //   maxYear: this.year+15,
  //   closeAfterSelect: true
  // }
  // public myDatePickerOptions: IMyOptions = this.DatePickerGlobalOptions;

  showFiles() {
    let files = '';
    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    return files;
  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }

  private setForm(result: Organization): void {

    if (this.isSuperAdmin) {
      this.orgForm = new UntypedFormGroup({
        ADDRESS1: new UntypedFormControl(result.ADDRESS1),
        ADDRESS2: new UntypedFormControl(result.ADDRESS2),
        CITY: new UntypedFormControl(result.CITY),
        CODE: new UntypedFormControl({ value: result.CODE, disabled: (this.Content.heading !== 'Add' && this.user !== 'superadmin@techsol.com') }, [Validators.pattern("^[0-9a-zA-Z]+$"), Validators.maxLength(50)]),
        COUNTRY: new UntypedFormControl(result.COUNTRY),
        CREATED_BY: new UntypedFormControl(result.CREATED_BY),
        CREATED_DATE: new UntypedFormControl(result.CREATED_DATE),
        DEFAULT_CURRENCY_ID: new UntypedFormControl(result.DEFAULT_CURRENCY_ID),
        DONT_ALLOW_DICTIONARY_WORDS: new UntypedFormControl(result.DONT_ALLOW_DICTIONARY_WORDS),
        //EAP: new UntypedFormControl({ value: result.EAP, disabled: (this.Content.heading === 'View' && this.user !== 'superadmin@techsol.com') }),
        EAP: new UntypedFormControl({ value: result.EAP, disabled: true}),
        IST_DISPLAY_NAME: new UntypedFormControl(this.Content.heading != "Add"?result.IST_DISPLAY_NAME:'Investigator Sponsored Trial'),
        EAP_DISPLAY_NAME: new UntypedFormControl("Expanded Access Program"),
        GRANTS_DISPLAY_NAME: new UntypedFormControl({value:(this.Content.heading != "Add"?result.GRANTS_DISPLAY_NAME:"Grants"),disabled:result.GRANTS==false}),
        
        EMAIL: new UntypedFormControl({ value: result.EMAIL, disabled: (this.Content.heading !== 'Add' && this.user !== 'superadmin@techsol.com') }),
        FAX_NO: new UntypedFormControl(result.FAX_NO, [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
        FAX_NO_EXT: new UntypedFormControl(result.FAX_NO_EXT, [Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
        GRANTS: new UntypedFormControl({ value: result.GRANTS, disabled: (this.Content.heading === 'View' && this.user !== 'superadmin@techsol.com') }),
        ID: new UntypedFormControl(result.ID),
        IST: new UntypedFormControl({ value: result.IST, disabled: (this.Content.heading === 'View' && this.user !== 'superadmin@techsol.com') }),
        IS_NUM_MANDATE_IN_PWD: new UntypedFormControl(result.IS_NUM_MANDATE_IN_PWD),
        IS_PASSWORD_POLICY_APPLICABLE: new UntypedFormControl(result.IS_PASSWORD_POLICY_APPLICABLE),
        IS_SPC_CHAR_MANDATE_IN_PWD: new UntypedFormControl(result.IS_SPC_CHAR_MANDATE_IN_PWD),
        IS_UPPER_MANDATE_IN_PWD: new UntypedFormControl(result.IS_UPPER_MANDATE_IN_PWD),
        LANGUAGE_ID: new UntypedFormControl(result.LANGUAGE_ID),
        LAST_UPDATED_BY: new UntypedFormControl(result.LAST_UPDATED_BY),
        LAST_UPDATED_DATE: new UntypedFormControl(result.LAST_UPDATED_DATE),
        LICENCE_END_DATE: new UntypedFormControl((result.LICENCE_END_DATE)?(new Date(result.LICENCE_END_DATE?.toString().replace('Z',''))):null),
        LOGIN_ATTEMPTS_TO_DISABLE: new UntypedFormControl(result.LOGIN_ATTEMPTS_TO_DISABLE),
        LOGO: new UntypedFormControl(result.LOGO),
        MAIN_HEADER: new UntypedFormControl(result.MAIN_HEADER),
        MIN_PASSWORD_LENGTH: new UntypedFormControl(result.MIN_PASSWORD_LENGTH),
        NAME: new UntypedFormControl({ value: result.NAME, disabled: (this.Content.heading !== 'Add' && this.user !== 'superadmin@techsol.com') }),
        NO_OF_PREV_PASS_MATCH_NEW_PWD: new UntypedFormControl(result.NO_OF_PREV_PASS_MATCH_NEW_PWD),
        OBS_CODE: new UntypedFormControl(result.OBS_CODE),
        ORGANIZATION_ID: new UntypedFormControl(result.ORGANIZATION_ID),
        PASSWORD_EXPIRY_DATE: new UntypedFormControl(result.PASSWORD_EXPIRY_DATE),
        PHONE_NO: new UntypedFormControl(result.PHONE_NO, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
        PHONE_NO_EXT: new UntypedFormControl(result.PHONE_NO_EXT, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
        RECORD_STATE: new UntypedFormControl(result.RECORD_STATE),
        STATE: new UntypedFormControl(result.STATE),
        SUB_HEADER: new UntypedFormControl(result.SUB_HEADER),
        WEB_SITE: new UntypedFormControl(result.WEB_SITE),
        ZIP: new UntypedFormControl(result.ZIP),
        IST_CURRENCY_ID: new UntypedFormControl({ value: result.IST_CURRENCY_ID, disabled: (this.Content.heading !== 'Add' && this.user !== 'superadmin@techsol.com') }),
        EAP_CURRENCY_ID: new UntypedFormControl({ value: result.EAP_CURRENCY_ID, disabled: (this.Content.heading !== 'Add' && this.user !== 'superadmin@techsol.com') }),
        CME_CURRENCY_ID: new UntypedFormControl({ value: result.CME_CURRENCY_ID, disabled: (this.Content.heading !== 'Add' && this.user !== 'superadmin@techsol.com') }),
        CHARITABLE_CURRENCY_ID: new UntypedFormControl({ value: result.CHARITABLE_CURRENCY_ID, disabled: (this.Content.heading !== 'Add' && this.user !== 'superadmin@techsol.com') }),
        SPONSERSHIP_CURRENCY_ID: new UntypedFormControl({ value: result.SPONSERSHIP_CURRENCY_ID, disabled: (this.Content.heading !== 'Add' && this.user !== 'superadmin@techsol.com') }),
        FILEID: new UntypedFormControl(result.FILEID),
        FILENAME: new UntypedFormControl(result.FILENAME),
        DSFILEID: new UntypedFormControl({ value: result.DSFILEID }),
        DSFILENAME: new UntypedFormControl({ value: result.DSFILENAME }),
        ACTIVE_USERS_LIMIT: new UntypedFormControl(result.ACTIVE_USERS_LIMIT),
        SPACE_ALLOCATION_BG: new UntypedFormControl(result.SPACE_ALLOCATION_BG),
        DATAPEROID_IN_YEARS: new UntypedFormControl(result.DATAPEROID_IN_YEARS),
        REPRESENTATIVE_NAME: new UntypedFormControl(result.REPRESENTATIVE_NAME),
        REPRESENTATIVE_EMAIL: new UntypedFormControl(result.REPRESENTATIVE_EMAIL),
        REPRESENTATIVE_PHONE_NO: new UntypedFormControl(result.REPRESENTATIVE_PHONE_NO),
        REPRESENTATIVE_PHONE_NO_EXT: new UntypedFormControl(result.REPRESENTATIVE_PHONE_NO_EXT, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
        REPRESENTATIVE_ADDRESS: new UntypedFormControl(result.REPRESENTATIVE_ADDRESS),
        ADMINISTRATOR_NAME: new UntypedFormControl(result.ADMINISTRATOR_NAME),
        ADMINISTRATOR_EMAIL: new UntypedFormControl({ value: result.ADMINISTRATOR_EMAIL, disabled: (this.Content.heading !== 'Add') }),
        ADMINISTRATOR_EMAIL_CONFIRM: new UntypedFormControl({ value: result.ADMINISTRATOR_EMAIL, disabled: (this.Content.heading !== 'Add') }),
        ADMINISTRATOR_PHONE_NO: new UntypedFormControl(result.ADMINISTRATOR_PHONE_NO),
        ADMINISTRATOR_PHONE_NO_EXT: new UntypedFormControl(result.ADMINISTRATOR_PHONE_NO_EXT, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
        ADMINISTRATOR_ADDRESS: new UntypedFormControl(result.ADMINISTRATOR_ADDRESS),
        AUTHTYPE: new UntypedFormControl(result.AUTHTYPE),
        ACTIVE: new UntypedFormControl(true),
        baseU: new UntypedFormControl({ value: result.WEB_SITE, disabled: true }),
        ACC_ACTIVITY: new UntypedFormControl(result.FK_ACC_ATVY_EMAILID),
        CORR_ACTIVITY: new UntypedFormControl(result.FK_CORRES_EMAILID),
        TIMEZONE: new UntypedFormControl(result.TIMEZONE),
        IS_ANALYTICS_CONFIGURED: new UntypedFormControl(result.IS_ANALYTICS_CONFIGURED),
        LOGI_URL: new UntypedFormControl(result.LOGI_URL, [Validators.maxLength(1000)]),
        LOGI_CLIENTID: new UntypedFormControl(result.LOGI_CLIENTID, [Validators.maxLength(1000)]),
        LOGI_CLIENT_SECRET: new UntypedFormControl(result.LOGI_CLIENT_SECRET, [Validators.maxLength(1000)]),
        LOGI_SUPERVISOR_USERNAME: new UntypedFormControl(result.LOGI_SUPERVISOR_USERNAME, [Validators.maxLength(100)]),
        LOGI_SUPERVISOR_PASSWORD: new UntypedFormControl(result.LOGI_SUPERVISOR_PASSWORD, [Validators.maxLength(100)]),
        LOGI_ADMIN_USERNAME: new UntypedFormControl(result.LOGI_ADMIN_USERNAME),
        LOGI_ADMIN_PASSWORD: new UntypedFormControl(result.LOGI_ADMIN_PASSWORD),
        LOGI_ADMIN_ACCESSTOKEN: new UntypedFormControl(result.LOGI_ADMIN_ACCESSTOKEN),
        IS_ORG_ACCOUNT_IN_LOGI: new UntypedFormControl(result.IS_ORG_ACCOUNT_IN_LOGI),
        CME: new UntypedFormControl({
          value: result.CME,
          disabled:
            this.Content.heading !== "Add" &&
            this.user !== "superadmin@techsol.com",
        }),
        SPONSERSHIP: new UntypedFormControl({
          value: result.SPONSERSHIP,
          disabled:
            this.Content.heading !== "Add" &&
            this.user !== "superadmin@techsol.com",
        }),
        CHARITY: new UntypedFormControl({
          value: result.CHARITY,
          disabled:
            this.Content.heading !== "Add" &&
            this.user !== "superadmin@techsol.com",
        }),
        CME_DISPLAY_NAME: new UntypedFormControl({value:(this.Content.heading != "Add"?result.CME_DISPLAY_NAME:"Continuing Medical Education"),disabled:(result.CME==false||result.GRANTS==false)}),
        CHARITY_DISPLAY_NAME: new UntypedFormControl({value:(this.Content.heading != "Add"?result.CHARITY_DISPLAY_NAME:"Charitable"),disabled:(result.CHARITY==false||result.GRANTS==false)}),
        SPONSERSHIP_DISPLAY_NAME: new UntypedFormControl({value:(this.Content.heading != "Add"?result.SPONSERSHIP_DISPLAY_NAME:"Sponsorship"),disabled:(result.SPONSERSHIP==false||result.GRANTS==false)}),

      })
      let date=new Date(result.LICENCE_END_DATE?.toString().replace('Z', ''));
      this.orgForm.controls["LICENCE_END_DATE"].setValue(date);
      if(result.RECORD_STATE==0)
      {
         this.orgForm.controls["ACTIVE"].setValue(false);
        
      }
      if (result.RECORD_STATE == 0) {
        this.orgForm.controls["ACTIVE"].setValue(false);
      }
      this.userService.getLogo(result.CODE).subscribe(resultlogo => {
        if (resultlogo === null || resultlogo === undefined || resultlogo === '') {
        }
        else {
          if (resultlogo.FileExt == 'svg') {
            this.url = 'data:image/svg+xml;base64,' + resultlogo.Image;
          }
          else {
            this.url = 'data:image/png;base64,' + resultlogo.Image;
          }
        }
      });
      this.Content.orgname = result.NAME;
   
    }
    else {
      this.orgForm = new UntypedFormGroup({
        ADDRESS1: new UntypedFormControl({ value: result.ADDRESS1, disabled: false }),
        ADDRESS2: new UntypedFormControl({ value: result.ADDRESS2, disabled: false }),
        CITY: new UntypedFormControl({ value: result.CITY, disabled: false }),
        CODE: new UntypedFormControl({ value: result.CODE, disabled: true }),
        COUNTRY: new UntypedFormControl({ value: result.COUNTRY, disabled: false }),
        CREATED_BY: new UntypedFormControl({ value: result.CREATED_BY, disabled: true }),
        CREATED_DATE: new UntypedFormControl({ value: result.CREATED_DATE, disabled: true }),
        DEFAULT_CURRENCY_ID: new UntypedFormControl(result.DEFAULT_CURRENCY_ID),
        DONT_ALLOW_DICTIONARY_WORDS: new UntypedFormControl({ value: result.DONT_ALLOW_DICTIONARY_WORDS, disabled: true }),
        EAP: new UntypedFormControl({ value: result.EAP, disabled: true }),
        EMAIL: new UntypedFormControl({ value: result.EMAIL, disabled: false }),
        FAX_NO: new UntypedFormControl({ value: result.FAX_NO, disabled: false }, [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
        FAX_NO_EXT: new UntypedFormControl({ value: result.FAX_NO_EXT, disabled: false }, [Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
        GRANTS: new UntypedFormControl({ value: result.GRANTS, disabled: true }),
        ID: new UntypedFormControl(result.ID),
        IST: new UntypedFormControl({ value: result.IST, disabled: true }),
        IS_NUM_MANDATE_IN_PWD: new UntypedFormControl({ value: result.IS_NUM_MANDATE_IN_PWD, disabled: true }),
        IS_PASSWORD_POLICY_APPLICABLE: new UntypedFormControl({ value: result.IS_PASSWORD_POLICY_APPLICABLE, disabled: true }),
        IS_SPC_CHAR_MANDATE_IN_PWD: new UntypedFormControl({ value: result.IS_SPC_CHAR_MANDATE_IN_PWD, disabled: true }),
        IS_UPPER_MANDATE_IN_PWD: new UntypedFormControl({ value: result.IS_UPPER_MANDATE_IN_PWD, disabled: true }),
        LANGUAGE_ID: new UntypedFormControl(result.LANGUAGE_ID),
        LAST_UPDATED_BY: new UntypedFormControl(result.LAST_UPDATED_BY),
        LAST_UPDATED_DATE: new UntypedFormControl(result.LAST_UPDATED_DATE),
        LICENCE_END_DATE: new UntypedFormControl({ value: new Date(result.LICENCE_END_DATE?.toString().replace('Z','')), disabled: true }),
        LOGIN_ATTEMPTS_TO_DISABLE: new UntypedFormControl({ value: result.LOGIN_ATTEMPTS_TO_DISABLE, disabled: true }),
        LOGO: new UntypedFormControl({ value: result.LOGO, disabled: true }),
        MAIN_HEADER: new UntypedFormControl({ value: result.MAIN_HEADER, disabled: false }),
        MIN_PASSWORD_LENGTH: new UntypedFormControl({ value: result.MIN_PASSWORD_LENGTH, disabled: true }),
        NAME: new UntypedFormControl({ value: result.NAME, disabled: false }),
        NO_OF_PREV_PASS_MATCH_NEW_PWD: new UntypedFormControl({ value: result.NO_OF_PREV_PASS_MATCH_NEW_PWD, disabled: true }),
        OBS_CODE: new UntypedFormControl({ value: result.OBS_CODE, disabled: true }),
        ORGANIZATION_ID: new UntypedFormControl({ value: result.ORGANIZATION_ID, disabled: true }),
        PASSWORD_EXPIRY_DATE: new UntypedFormControl({ value: result.PASSWORD_EXPIRY_DATE, disabled: true }),
        PHONE_NO: new UntypedFormControl({ value: result.PHONE_NO, disabled: false }, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
        PHONE_NO_EXT: new UntypedFormControl({ value: result.PHONE_NO_EXT, disabled: false }, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
        RECORD_STATE: new UntypedFormControl({ value: result.RECORD_STATE, disabled: true }),
        STATE: new UntypedFormControl({ value: result.STATE, disabled: false }),
        SUB_HEADER: new UntypedFormControl(result.SUB_HEADER),
        WEB_SITE: new UntypedFormControl({ value: result.WEB_SITE, disabled: false }),
        ZIP: new UntypedFormControl({ value: result.ZIP, disabled: false }),
        IST_CURRENCY_ID: new UntypedFormControl({ value: result.IST_CURRENCY_ID, disabled: false }),
        EAP_CURRENCY_ID: new UntypedFormControl({ value: result.EAP_CURRENCY_ID, disabled: false }),
        CME_CURRENCY_ID: new UntypedFormControl({ value: result.CME_CURRENCY_ID, disabled: false }),
        CHARITABLE_CURRENCY_ID: new UntypedFormControl({ value: result.CHARITABLE_CURRENCY_ID, disabled: false }),
        SPONSERSHIP_CURRENCY_ID: new UntypedFormControl({ value: result.SPONSERSHIP_CURRENCY_ID, disabled: false }),
        FILEID: new UntypedFormControl({ value: result.FILEID, disabled: true }),
        FILENAME: new UntypedFormControl({ value: result.FILENAME, disabled: true }),
        DSFILEID: new UntypedFormControl({ value: result.DSFILEID, disabled: true }),
        DSFILENAME: new UntypedFormControl({ value: result.DSFILENAME, disabled: true }),
        ACTIVE_USERS_LIMIT: new UntypedFormControl({ value: result.ACTIVE_USERS_LIMIT, disabled: true }),
        SPACE_ALLOCATION_BG: new UntypedFormControl({ value: result.SPACE_ALLOCATION_BG, disabled: true }),
        DATAPEROID_IN_YEARS: new UntypedFormControl({ value: result.DATAPEROID_IN_YEARS, disabled: true }),
        REPRESENTATIVE_NAME: new UntypedFormControl(result.REPRESENTATIVE_NAME),
        REPRESENTATIVE_EMAIL: new UntypedFormControl(result.REPRESENTATIVE_EMAIL),
        REPRESENTATIVE_PHONE_NO: new UntypedFormControl(result.REPRESENTATIVE_PHONE_NO),
        REPRESENTATIVE_PHONE_NO_EXT: new UntypedFormControl(result.REPRESENTATIVE_PHONE_NO_EXT),
        REPRESENTATIVE_ADDRESS: new UntypedFormControl(result.REPRESENTATIVE_ADDRESS),
        ADMINISTRATOR_NAME: new UntypedFormControl({ value: result.ADMINISTRATOR_NAME, disabled: true }),
        ADMINISTRATOR_EMAIL: new UntypedFormControl({ value: result.ADMINISTRATOR_EMAIL, disabled: true }),
        ADMINISTRATOR_EMAIL_CONFIRM: new UntypedFormControl({ value: result.ADMINISTRATOR_EMAIL, disabled: true }),
        ADMINISTRATOR_PHONE_NO: new UntypedFormControl({ value: result.ADMINISTRATOR_PHONE_NO, disabled: true }),
        ADMINISTRATOR_PHONE_NO_EXT: new UntypedFormControl({ value: result.ADMINISTRATOR_PHONE_NO_EXT, disabled: true }),
        ADMINISTRATOR_ADDRESS: new UntypedFormControl({ value: result.ADMINISTRATOR_ADDRESS, disabled: true }),
        AUTHTYPE: new UntypedFormControl({ value: result.AUTHTYPE, disabled: true }),
        ACTIVE: new UntypedFormControl({ value: true, disabled: true }),
        baseU: new UntypedFormControl({ value: result.WEB_SITE, disabled: true }),
        ACC_ACTIVITY: new UntypedFormControl(result.FK_ACC_ATVY_EMAILID==null?"":result.FK_ACC_ATVY_EMAILID),
        CORR_ACTIVITY: new UntypedFormControl(result.FK_CORRES_EMAILID==null?"":result.FK_CORRES_EMAILID),
        TIMEZONE : new UntypedFormControl((result.TIMEZONE == null || result.TIMEZONE == undefined) ? 'UTC' : result.TIMEZONE),
        CHARITY: new UntypedFormControl({value: result.CHARITY,disabled:result.GRANTS==false|| this.ISCHARITYData,}),
        SPONSERSHIP: new UntypedFormControl({value: result.SPONSERSHIP,disabled: result.GRANTS==false||this.ISSPONSERSHIPData,}),
        CME: new UntypedFormControl({ value: result.CME, disabled:result.GRANTS==false|| this.ISCMEData }),

        IST_DISPLAY_NAME: new UntypedFormControl({ value: result.IST_DISPLAY_NAME, disabled: true }),
        EAP_DISPLAY_NAME: new UntypedFormControl({ value: result.EAP_DISPLAY_NAME, disabled: true }),
        GRANTS_DISPLAY_NAME: new UntypedFormControl({ value: result.GRANTS_DISPLAY_NAME, disabled: true }),
        CME_DISPLAY_NAME: new UntypedFormControl({ value: result.CME_DISPLAY_NAME, disabled: true }),
        CHARITY_DISPLAY_NAME: new UntypedFormControl({ value: result.CHARITY_DISPLAY_NAME, disabled: true }),
        SPONSERSHIP_DISPLAY_NAME: new UntypedFormControl({ value: result.SPONSERSHIP_DISPLAY_NAME, disabled: true })
      });
      
       //this.orgForm.controls["LICENCE_END_DATE"].valuesetValue(LICENCE_END_DATE);
      if(result.RECORD_STATE==0)
      {
         this.orgForm.controls["ACTIVE"].setValue(false);
      }
      this.userService.getLogo(result.CODE).subscribe(resultlogo => {
        if (resultlogo === null || resultlogo === undefined || resultlogo === '') {
        }
        else {
          if (resultlogo.FileExt == 'svg') {
            this.url = 'data:image/svg+xml;base64,' + resultlogo.Image;
          }
          else {
            this.url = 'data:image/png;base64,' + resultlogo.Image;
          }
        }
      });
    }

    let todaysdate = new Date() ; todaysdate.setHours(0,0,0,0)
    let saved_date : Date =  this.orgForm.controls["LICENCE_END_DATE"].value;
          const today = new Date(); today.setHours(0,0,0,0)
      let date = new Date(this.LicenseEndDate);

        setTimeout(() => { 
          while (date < today) {
            this.disabledDates.push(new Date(date));
            date.setDate(date.getDate() + 1);
          }
        }, 1000); 

        setTimeout(() => { 
        if((saved_date < todaysdate) && saved_date!=null)
            this.minDate = saved_date;
        }, 0); 

          setTimeout(() => {
            this.orgForm.controls["LICENCE_END_DATE"].setValue(this.LicenseEndDate)  
          }, 0);  
          this.CME_Module=this.orgForm.controls['CME']?.value;
          this.CHARITY_Module=this.orgForm.controls['CHARITY']?.value;
          this.SPONSERSHIP_Module=this.orgForm.controls['SPONSERSHIP']?.value;


  }

  public IsCheck(event) {
    if (this.orgForm.controls['IST']?.value) {
      this.orgForm.controls['IST_DISPLAY_NAME']?.enable();
    }

    else {
      this.orgForm.controls['IST_DISPLAY_NAME']?.disable()
    }
    if (this.Content.heading == 'Add') {
      if (this.orgForm.controls['GRANTS']?.value) {
        this.orgForm.controls['CME']?.setValue(true);
        this.orgForm.controls['CHARITY']?.setValue(true);
        this.orgForm.controls['SPONSERSHIP']?.setValue(true);

        this.orgForm.controls['GRANTS_DISPLAY_NAME']?.enable();
        this.orgForm.controls['CME_DISPLAY_NAME']?.enable();
        this.orgForm.controls['CHARITY_DISPLAY_NAME']?.enable();
        this.orgForm.controls['SPONSERSHIP_DISPLAY_NAME']?.enable();
      }
      else {
        this.orgForm.controls['CME']?.setValue(false);
        this.orgForm.controls['CHARITY']?.setValue(false);
        this.orgForm.controls['SPONSERSHIP']?.setValue(false);

        this.orgForm.controls['GRANTS_DISPLAY_NAME']?.disable();
        this.orgForm.controls['CME_DISPLAY_NAME']?.disable();
        this.orgForm.controls['CHARITY_DISPLAY_NAME']?.disable();
        this.orgForm.controls['SPONSERSHIP_DISPLAY_NAME']?.disable();
      }

    }
    else {
      if (!this.CME_Module && !this.CHARITY_Module && !this.SPONSERSHIP_Module) {
        if (this.orgForm.controls['GRANTS']?.value) {
          this.orgForm.controls['CME']?.setValue(true);
          this.orgForm.controls['CHARITY']?.setValue(true);
          this.orgForm.controls['SPONSERSHIP']?.setValue(true);
  
          this.orgForm.controls['GRANTS_DISPLAY_NAME']?.enable();
          this.orgForm.controls['CME_DISPLAY_NAME']?.enable();
          this.orgForm.controls['CHARITY_DISPLAY_NAME']?.enable();
          this.orgForm.controls['SPONSERSHIP_DISPLAY_NAME']?.enable();
        }
        else{
          this.orgForm.controls['CME']?.setValue(false);
          this.orgForm.controls['CHARITY']?.setValue(false);
          this.orgForm.controls['SPONSERSHIP']?.setValue(false);
  
          this.orgForm.controls['GRANTS_DISPLAY_NAME']?.disable();
          this.orgForm.controls['CME_DISPLAY_NAME']?.disable();
          this.orgForm.controls['CHARITY_DISPLAY_NAME']?.disable();
          this.orgForm.controls['SPONSERSHIP_DISPLAY_NAME']?.disable();
        }
        
      }
      else {

        if (!this.orgForm.controls['GRANTS']?.value) {
          this.orgForm.controls['GRANTS_DISPLAY_NAME']?.disable();
        }
        else {
          this.orgForm.controls['GRANTS_DISPLAY_NAME']?.enable();
        }

        if (!this.orgForm.controls['CME']?.value || !this.orgForm.controls['GRANTS']?.value) {
          this.orgForm.controls['CME_DISPLAY_NAME']?.disable();
        }
        else {
          this.orgForm.controls['CME_DISPLAY_NAME']?.enable();
        }

        if (!this.orgForm.controls['CHARITY']?.value || !this.orgForm.controls['GRANTS']?.value) {
          this.orgForm.controls['CHARITY_DISPLAY_NAME']?.disable();
        }
        else {
          this.orgForm.controls['CHARITY_DISPLAY_NAME']?.enable();
        }

        if (!this.orgForm.controls['SPONSERSHIP']?.value || !this.orgForm.controls['GRANTS']?.value) {
          this.orgForm.controls['SPONSERSHIP_DISPLAY_NAME']?.disable();
        }
        else {
          this.orgForm.controls['SPONSERSHIP_DISPLAY_NAME']?.enable();
        }
      }

    }
  }
  




  private getForm(): Organization {
    const formModel = this.orgForm.getRawValue();
    let org = new Organization();
    org = {
      ADDRESS1: formModel.ADDRESS1 || '',
      ADDRESS2: formModel.ADDRESS2 || '',
      CITY: formModel.CITY || '',
      CODE: formModel.CODE || '',
      COUNTRY: formModel.COUNTRY || '',
      CREATED_BY: null,
      CREATED_DATE: '2020-08-11',
      DEFAULT_CURRENCY_ID: null,
      DONT_ALLOW_DICTIONARY_WORDS: null,
      EAP: Boolean(formModel.EAP) || false,
      EMAIL: formModel.EMAIL || '',
      FAX_NO: formModel.FAX_NO || '',
      FAX_NO_EXT: Number(formModel.FAX_NO_EXT) || null,
      GRANTS: Boolean(formModel.GRANTS) || false,
      ID: formModel.ID || '',
      IST: Boolean(formModel.IST) || false,
      IS_NUM_MANDATE_IN_PWD: null,
      IS_PASSWORD_POLICY_APPLICABLE: null,
      IS_SPC_CHAR_MANDATE_IN_PWD: null,
      IS_UPPER_MANDATE_IN_PWD: null,
      LANGUAGE_ID: null,
      LAST_UPDATED_BY: null,
      LAST_UPDATED_DATE: '2020-08-11',
      LICENCE_END_DATE: formModel.LICENCE_END_DATE || null,
      LICENCE_END_DATES: null,
      LICENCE_END_DATEO: null,
      LOGIN_ATTEMPTS_TO_DISABLE: null,
      LOGO: formModel.LOGO || '',
      MAIN_HEADER: formModel.MAIN_HEADER || '',
      MIN_PASSWORD_LENGTH: null,
      NAME: formModel.NAME || '',
      NO_OF_PREV_PASS_MATCH_NEW_PWD: null,
      OBS_CODE: null,
      ORGANIZATION_ID: null,
      PASSWORD_EXPIRY_DATE: null,
      PHONE_NO: formModel.PHONE_NO || '',
      PHONE_NO_EXT: Number(formModel.PHONE_NO_EXT) || null,
      RECORD_STATE: Number(formModel.ACTIVE) || 0,
      STATE: formModel.STATE || '',
      SUB_HEADER: formModel.SUB_HEADER || '',
      WEB_SITE: formModel.WEB_SITE || '',
      ZIP: formModel.ZIP || '',
      IST_CURRENCY_ID: formModel.IST_CURRENCY_ID || '',
      EAP_CURRENCY_ID: formModel.EAP_CURRENCY_ID || '',
      CME_CURRENCY_ID: formModel.CME_CURRENCY_ID || '',
      CHARITABLE_CURRENCY_ID: formModel.CHARITABLE_CURRENCY_ID || '',
      SPONSERSHIP_CURRENCY_ID: formModel.SPONSERSHIP_CURRENCY_ID || '',
      FILEID: '',
      FILENAME: '',
      DSFILEID: '',
      DSFILENAME: '',
      ACTIVE_USERS_LIMIT: Number(formModel.ACTIVE_USERS_LIMIT) || 0,
      SPACE_ALLOCATION_BG: Number(formModel.SPACE_ALLOCATION_BG) || 0,
      DATAPEROID_IN_YEARS: Number(formModel.DATAPEROID_IN_YEARS) || 0,
      REPRESENTATIVE_NAME: formModel.REPRESENTATIVE_NAME || '',
      REPRESENTATIVE_EMAIL: formModel.REPRESENTATIVE_EMAIL || '',
      REPRESENTATIVE_PHONE_NO: formModel.REPRESENTATIVE_PHONE_NO || '',
      REPRESENTATIVE_PHONE_NO_EXT: Number(formModel.REPRESENTATIVE_PHONE_NO_EXT) || 0,
      REPRESENTATIVE_ADDRESS: formModel.REPRESENTATIVE_ADDRESS || '',
      ADMINISTRATOR_NAME: formModel.ADMINISTRATOR_NAME || '',
      ADMINISTRATOR_EMAIL: formModel.ADMINISTRATOR_EMAIL || '',
      ADMINISTRATOR_PHONE_NO: formModel.ADMINISTRATOR_PHONE_NO || '',
      ADMINISTRATOR_PHONE_NO_EXT: Number(formModel.ADMINISTRATOR_PHONE_NO_EXT) || 0,
      ADMINISTRATOR_ADDRESS: formModel.ADMINISTRATOR_ADDRESS || '',
      AUTHTYPE: formModel.AUTHTYPE || 'MED',
      FK_ACC_ATVY_EMAILID:formModel.ACC_ACTIVITY,
      FK_CORRES_EMAILID:formModel.CORR_ACTIVITY,
      TIMEZONE : formModel.TIMEZONE || "UTC",

 

      // TIMEZONE : new UntypedFormControl(result.TIMEZONE ==null ? '(UTC) Coordinated Universal Time':result.TIMEZONE)
      CME: Boolean(formModel.CME) || false,
      CHARITY: Boolean(formModel.CHARITY) || false,
      SPONSERSHIP: Boolean(formModel.SPONSERSHIP) || false,
  
      IS_ANALYTICS_CONFIGURED: Boolean(formModel.IS_ANALYTICS_CONFIGURED) || false,
      LOGI_URL: formModel.LOGI_URL || '',
      LOGI_CLIENTID: formModel.LOGI_CLIENTID || '',
      LOGI_CLIENT_SECRET: formModel.LOGI_CLIENT_SECRET || '',
      LOGI_SUPERVISOR_USERNAME: formModel.LOGI_SUPERVISOR_USERNAME || '',
      LOGI_SUPERVISOR_PASSWORD: formModel.LOGI_SUPERVISOR_PASSWORD || '',
      LOGI_ADMIN_USERNAME: formModel.LOGI_ADMIN_USERNAME || '',
      LOGI_ADMIN_PASSWORD: formModel.LOGI_ADMIN_PASSWORD || '',
      LOGI_ADMIN_ACCESSTOKEN: formModel.LOGI_ADMIN_ACCESSTOKEN || '',
      IS_ORG_ACCOUNT_IN_LOGI: Boolean(formModel.IS_ORG_ACCOUNT_IN_LOGI) || false,
      CANREFRESH :Boolean(formModel.CANREFRESH) || false,

      IST_DISPLAY_NAME: formModel.IST_DISPLAY_NAME || '',
      EAP_DISPLAY_NAME: formModel.EAP_DISPLAY_NAME || '',
      GRANTS_DISPLAY_NAME: formModel.GRANTS_DISPLAY_NAME || '',
      CME_DISPLAY_NAME: formModel.CME_DISPLAY_NAME || '',
      CHARITY_DISPLAY_NAME: formModel.CHARITY_DISPLAY_NAME || '',
      SPONSERSHIP_DISPLAY_NAME: formModel.SPONSERSHIP_DISPLAY_NAME || '',
    };

    if (this.Content.heading !== 'Add' && this.user !== 'superadmin@scimaxglobal.com') {
      // Address for communication
      this.organization.ADDRESS1 = org.ADDRESS1;
      this.organization.ADDRESS2 = org.ADDRESS2;
      this.organization.ZIP = org.ZIP;
      this.organization.CITY = org.CITY;
      this.organization.COUNTRY = org.COUNTRY;
      this.organization.STATE = org.STATE;
      this.organization.PHONE_NO = org.PHONE_NO;
      this.organization.PHONE_NO_EXT = org.PHONE_NO_EXT;
      this.organization.FAX_NO = org.FAX_NO;
      this.organization.FAX_NO_EXT = org.FAX_NO_EXT;
      this.organization.WEB_SITE = org.WEB_SITE;
      this.organization.EMAIL = org.EMAIL;
      this.organization.NAME = org.NAME;

      this.organization.CITY = org.CITY;
      this.organization.DEFAULT_CURRENCY_ID = org.DEFAULT_CURRENCY_ID;
      this.organization.ID = org.ID;
      this.organization.LANGUAGE_ID = org.LANGUAGE_ID;
      this.organization.LAST_UPDATED_BY = org.LAST_UPDATED_BY;
      this.organization.LAST_UPDATED_DATE = org.LAST_UPDATED_DATE;
      this.organization.MAIN_HEADER = org.MAIN_HEADER;
      this.organization.SUB_HEADER = org.SUB_HEADER;
      this.organization.IST_CURRENCY_ID = org.IST_CURRENCY_ID;
      this.organization.EAP_CURRENCY_ID = org.EAP_CURRENCY_ID;
      this.organization.CME_CURRENCY_ID = org.CME_CURRENCY_ID;
      this.organization.CHARITABLE_CURRENCY_ID = org.CHARITABLE_CURRENCY_ID;
      this.organization.SPONSERSHIP_CURRENCY_ID = org.SPONSERSHIP_CURRENCY_ID;
      this.organization.REPRESENTATIVE_NAME = org.REPRESENTATIVE_NAME;
      this.organization.REPRESENTATIVE_EMAIL = org.REPRESENTATIVE_EMAIL;
      this.organization.REPRESENTATIVE_PHONE_NO = org.REPRESENTATIVE_PHONE_NO;
      this.organization.REPRESENTATIVE_PHONE_NO_EXT = org.REPRESENTATIVE_PHONE_NO_EXT;
      this.organization.REPRESENTATIVE_ADDRESS = org.REPRESENTATIVE_ADDRESS;
      const ldate = this.GetLicenseEndDate();
      this.organization.LICENCE_END_DATEO = ldate;
      this.organization.LICENCE_END_DATES = ldate.Year + "-" + ldate.Month + "-" + ldate.Day;
      this.organization.AUTHTYPE = org.AUTHTYPE;
      this.organization.TIMEZONE=org.TIMEZONE;
      this.organization.CME = org.CME;
      this.organization.CHARITY = org.CHARITY;
      this.organization.SPONSERSHIP = org.SPONSERSHIP;
      this.organization.FK_ACC_ATVY_EMAILID = org.FK_ACC_ATVY_EMAILID;
      this.organization.FK_CORRES_EMAILID = org.FK_CORRES_EMAILID;
      this.organization.LOGO = org.LOGO;
      return this.organization;
    }
    else {
      const ldate = this.GetLicenseEndDate();
      org.LICENCE_END_DATEO = ldate;
      org.LICENCE_END_DATES = ldate.Year + "-" + ldate.Month + "-" + ldate.Day;
      return org;
    }
  }

  IsLicenseEnd_DateModified: boolean = false;
  Full_LicenseEnd_Date: DateObject;

  onLicenseEndDateSelect(event) {
    this.IsLicenseEnd_DateModified = true;
    this.Full_LicenseEnd_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23, 
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.IsLicenseEnd_DateModified,
    }
  }

  GetLicenseEndDate(): DateObject {
   // const date = new Date(this.organization.LICENCE_END_DATE);
   const formModel = this.orgForm.getRawValue();
   const date = new Date(formModel.LICENCE_END_DATE);
    if (this.ComparingDates(this.LicenseEndDate, date) || this.Full_LicenseEnd_Date == null || this.Full_LicenseEnd_Date == undefined) {
      this.Full_LicenseEnd_Date = {
        Day: date.getDate(),
        Month: (date.getMonth() + 1),
        Year: date.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: false
      }
    }
    return this.Full_LicenseEnd_Date;
  }

  ComparingDates(oldDate: any, newDate: any) {
    if (oldDate != undefined && oldDate != null && oldDate != '') {
      let oDt = oldDate.getDate().toString() + oldDate.getMonth().toString() + oldDate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt)
        return true;
      else
        return false;
    }
    else
      return false;
  }

  save() {
    if (this.validateControls()) {
      if(this.isSuperAdmin){
        if (this.orgForm.controls["IS_ANALYTICS_CONFIGURED"].value) {
          var logiObj = {
            LogiURL: this.orgForm.controls["LOGI_URL"].value,
            ClientID: this.orgForm.controls["LOGI_CLIENTID"].value,
            ClientSecret: this.orgForm.controls["LOGI_CLIENT_SECRET"].value,
            SupervisorUsername: this.orgForm.controls["LOGI_SUPERVISOR_USERNAME"].value,
            SupervisorPWD: this.orgForm.controls["LOGI_SUPERVISOR_PASSWORD"].value,
          }
          this.summaryService.ValidateLogiConf(logiObj).subscribe(res => {
            if (res != null && res != undefined) {
              if (res.Status == 0) {
                this.SaveOrganization();
              }
              else {
                let message = "";
                message += "Below entered details are invalid. Please enter another details to save - <br/>";
                message += " URL <br/>";
                message += "Client ID <br/>";
                message += "Client Secret <br/>";
                message += "Supervisor Username <br/>";
                message += "Supervisor Password <br/>";
               
                this.commonservice.ValidationBanner(message);
              }
            }
          });
        }
        else {
          this.SaveOrganization();
        }
      }else{
        this.SaveOrganization();
      }
    }
  }

  SaveOrganization() {
    if (this.userService.getUserDetais().CODE === "SUPERADMIN") {
      this.email = "superadmin@scimaxglobal.com";
    }
    const userDetails = { CODE: this.email, PASSWORD: this.password, ORGCODE: this.userService.getOrgCode() }

    if (this.userService.getUserDetais().CODE === "SUPERADMIN" || this.email === "superadmin@scimaxglobal.com") {
      const formAttachments = new FormData();
      const data = this.getForm();
      data.CODE=data.CODE.trim();
      data.NAME=data.NAME.trim();
      data.IST_DISPLAY_NAME=data.IST_DISPLAY_NAME.trim();
      data.EAP_DISPLAY_NAME=data.EAP_DISPLAY_NAME.trim();
      data.GRANTS_DISPLAY_NAME=data.GRANTS_DISPLAY_NAME.trim();
      data.CME_DISPLAY_NAME=data.CME_DISPLAY_NAME.trim();
      data.CHARITY_DISPLAY_NAME=data.CHARITY_DISPLAY_NAME.trim();
      data.SPONSERSHIP_DISPLAY_NAME=data.SPONSERSHIP_DISPLAY_NAME.trim();
      if (this.document_attach_list !== null && this.document_attach_list.length > 0) {
        for (let i = 0; i < this.document_attach_list.length; i++) {
          this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
          formAttachments.append("LOGO", this.document_attach_list[i].File);
        }
      }
      else {
        if (this.url == null) {
          data.LOGO = "";
        }
        else { data.LOGO = data.LOGO; }
      }

          if (this.dsdocument_attach_list !== null && this.dsdocument_attach_list.length > 0) {
            for (let i = 0; i < this.dsdocument_attach_list.length; i++) {
              this.dsdocument_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
              formAttachments.append("DS", this.dsdocument_attach_list[i].File);
            }
          }
          if(this.Content.heading=='Add'){
            if (data.GRANTS)
              {
                data.CME = true;
                data.CHARITY = true;
                data.SPONSERSHIP = true;
              } 
              else
              {
                data.CME = false;
                data.CHARITY = false;
                data.SPONSERSHIP = false;
              }
          }
         

          data["URL"]=this.baseU +'/'+ data.CODE +'/login';
          formAttachments.append("ScreenData", JSON.stringify(data));
          if (!this.Content.content && this.Content.heading === 'Add') {
            this.summaryService.InsertWithFiles('api/organization/InsertOrganization', formAttachments).subscribe(result => {
              if (result.Status == 0) {
                this.commonService.SuccessBanner("Organization '" + data.NAME+ "' added successfully");

            this.modalRef.close();
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
          }
        })

          } 
          else if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit')
           {
            this.summaryService.InsertWithFiles('api/organization/UpdateOrganization', formAttachments).subscribe(result => {
              if (this.document_delete_list.length > 0) {
                this.summaryService.Delete("api/ISTFileAttachments/DeleteFile?FileID=" + this.document_delete_list[0].ID).subscribe(result => {
                });
              }
              if (this.dsdocument_delete_list.length > 0) {
                this.summaryService.Delete("api/ISTFileAttachments/DeleteFile?FileID=" + this.dsdocument_delete_list[0].ID).subscribe(result => {
                });
              }
              if (result.Status == 0) {
                this.commonService.SuccessBanner(result.Message);

                this.modalRef.close();
              }
              else {
                this.commonservice.ValidationBanner(result.Message);
              }

            })
          }

      }
      else {
        const formAttachments = new FormData();
        const data = this.getForm();
        if (this.document_attach_list !== null && this.document_attach_list.length > 0) {
          for (let i = 0; i < this.document_attach_list.length; i++) {
            this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
            formAttachments.append("LOGO", this.document_attach_list[i].File);
          }
        }
      else {
        if (this.url == null) {
          data.LOGO = "";
        }
        else { data.LOGO = data.LOGO; }
      }

        if (this.dsdocument_attach_list !== null && this.dsdocument_attach_list.length > 0) {
          for (let i = 0; i < this.dsdocument_attach_list.length; i++) {
            this.dsdocument_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
            formAttachments.append("DS", this.dsdocument_attach_list[i].File);
          }
        }
        data["URL"]=this.baseU +'/'+ data.CODE +'/login';
        if(!this.isSuperAdmin) {
          var ISTobj = this.istCurrlist.filter(function (element)
          {
            return element.value == data.IST_CURRENCY_ID;
          })[0];
          if (ISTobj != null && ISTobj != undefined) {
            data["ISTCurrency"] = ISTobj.label;
            }
          else {
            data["ISTCurrency"] = "";
            }
            var EAPobj = this.eapCurrlist.filter(function (element)
          {
            return element.value == data.EAP_CURRENCY_ID;
          })[0];
          if (EAPobj != null && EAPobj != undefined) {
            data["EAPCurrency"] = EAPobj.label;
            }
          else {
            data["EAPCurrency"] = "";
            }

            if (data.CME)
            {
              var G1obj = this.cmeCurrlist.filter(function (element)
              {
                return element.value == data.CME_CURRENCY_ID;
              })[0];
              if (G1obj != null && G1obj != undefined) {
                data["G1Currency"] = G1obj.label;
                }
              else {
                data["G1Currency"] = "";
                }
            }
            if (data.CHARITY)
            {
            var G2obj = this.charityCurrlist.filter(function (element)
          {
            return element.value == data.CHARITABLE_CURRENCY_ID;
          })[0];
          if (G2obj != null && G2obj != undefined) {
            data["G3Currency"] = G2obj.label;
            }
          else {
            data["G3Currency"] = "";
            }
          }
          if (data.SPONSERSHIP)
          {
            var G3obj = this.sponsorCurrlist.filter(function (element)
          {
            return element.value == data.SPONSERSHIP_CURRENCY_ID;
          })[0];
          if (G3obj != null && G3obj != undefined) {
            data["G2Currency"] = G3obj.label;
            }
          else {
            data["G2Currency"] = "";
            }
          }
            var Acobj = this.accemaillist.filter(function (element)
          {
            return element.value == data.FK_ACC_ATVY_EMAILID;
          })[0];
          
          if (Acobj != null && Acobj != undefined) {
            data["AccActivity"] = Acobj.label;
            }
          else {
            data["AccActivity"] = "";
            }

            var Crobj = this.crremaillist.filter(function (element)
          {
            return element.value == data.FK_CORRES_EMAILID;
          })[0];
          if (Crobj != null && Crobj != undefined) {
            data["Correspondence"] = Crobj.label;
            }
          else {
            data["Correspondence"] = "";
            }
          }
        formAttachments.append("ScreenData", JSON.stringify(data));
        if (!this.Content.content && this.Content.heading === 'Add') {

          this.summaryService.InsertWithFiles('api/organization/InsertOrganization', formAttachments).subscribe(result => {
            if (result.Status === 0) {
              this.commonService.SuccessBanner(result.Message);

              this.modalRef.close();
            }
            else {
              this.commonservice.ValidationBanner(result.Message);
            }
          })

      }
      else if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit') {
        this.summaryService.InsertWithFiles('api/organization/UpdateOrganization', formAttachments).subscribe(result => {
          if (this.document_delete_list.length > 0) {
            this.summaryService.Delete("api/ISTFileAttachments/DeleteFile?FileID=" + this.document_delete_list[0].ID).subscribe(result => {
            });
          }
          if (result.Status == 0) {
            if(result.Data!=null)
            {
            this.userService.setLoggedUserOrgTimeZone(result.Data.LoggedUserOrgTimeZone);

            this.userService.setISTCurrency(result.Data.IST_CURRENCY_ID);
            this.userService.setEAPCurrency(result.Data.EAP_CURRENCY_ID);
         
            this.userService.setGrantsCMECurrency(result.Data.GRANTS_CME_CURRENCY_ID);
            this.userService.setGrantscharitableCurrency(result.Data.GRANTS_CHARITABLE_CURRENCY_ID);
            this.userService.setGrantssponsorshipCurrency(result.Data.GRANTS_SPONSOR_CURRENCY_ID);

            this.userService.setGrantsCMECurrencysymbol(result.Data.GRANTS_CME_CURRENCY_SYMBOL);
            this.userService.setGrantsCMECurrencycode(result.Data.GRANTS_CME_CURRENCY_CODE);
            this.userService.setGrantssponsorshipCurrencysymbol(result.Data.GRANTS_SPONSOR_CURRENCY_SYMBOL);

            this.userService.setGrantssponsorshipCurrencycode(result.Data.GRANTS_SPONSOR_CURRENCY_CODE);
            this.userService.setGrantscharitableCurrencysymbol(result.Data.GRANTS_CHARITABLE_CURRENCY_SYMBOL);
            this.userService.setGrantscharitableCurrencycode(result.Data.GRANTS_CHARITABLE_CURRENCY_CODE);
            }
            this.commonService.SuccessBanner( result.Message);
            this.modalRef.close();
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
          }
        })
      }
    }
  }


  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event) => {
        // called once readAsDataURL is completed
        this.url = event.target.result;
      };
    }
  }
  uploadchange(event): void {
    var fileurl;
    var file = event.target.files[0].name;
    this.orgForm.controls["LOGO"].setValue(file);
    var ext = file.match(/\.([^\.]+)$/)[1];
    this.document_attach_list = [];
    this.organization.FILENAME = "";
    var filesize = event.target.files[0].size;
    var filewidth: any, fileheight: any;

    const URL = window.URL || window.webkitURL;
    const Img = new Image();

    const UploadFile = (event.target.files[0]);
    Img.src = URL.createObjectURL(UploadFile);

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]); // read file as data url
    reader.onload = (event) => {
      // called once readAsDataURL is completed
      fileurl = event.target.result;
      Img.src = fileurl;
    };  

    if (file != null && ((filesize > 10485760) || (ext != 'jpg' && ext != 'jpeg' && ext != 'svg' && ext != 'png') || fileheight > 100 || filewidth > 200)) {
      this.commonservice.ValidationBanner("Logo accepts only JPG, JPEG, SVG, PNG file types with maximum 10mb size and pxl (200*100)");
    }
    else {
      Img.onload = (e: any) => {
        fileheight = e.target.height;
        filewidth = e.target.width;
        if (file != null && ((filesize > 10485760) || (ext != 'jpg' && ext != 'jpeg' && ext != 'svg' && ext != 'png') || fileheight > 100 || filewidth > 200)) {
          this.commonservice.ValidationBanner("Logo accepts only JPG, JPEG, SVG, PNG file types with maximum 10mb size and pxl (200*100)");
          this.orgForm.controls["LOGO"].setValue('');
          this.url = null;
        }
        else {
          this.url = fileurl;
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = ("1");
          uploadFile.DOCUMENT_NAME = UploadFile.name;
          uploadFile.File = UploadFile;
          uploadFile.Status = "Add";
          this.document_attach_list.push(uploadFile);
        }
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    let isvalidMsg=true;
    const formData = this.orgForm.getRawValue();
    this.displayNames=[]

    if (this.isSuperAdmin)
     {
      if (!(this.Content.heading !== 'Add' && this.user !== 'superadmin@techsol.com')) {
        if (formData.CODE === null || formData.CODE === "" || formData.CODE === undefined) {
          $("#CODE").addClass("ng-touched ng-invalid validate-error");
          $("#CODE").removeClass("ng-untouched ng-valid");
          message += "Please enter Code <br/>";
          isValid = false;
        } else {
          $("#CODE").addClass("ng-untouched ng-valid");
          $("#CODE").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (!(this.Content.heading !== 'Add' && this.user !== 'superadmin@techsol.com')) {
        if(formData.NAME === null || formData.NAME === "" || formData.NAME === undefined){
          $("#NAME").addClass("ng-touched ng-invalid validate-error");
          $("#NAME").removeClass("ng-untouched ng-valid");
          message += "Please enter Organization Name <br/>";
          isValid = false;
       }
       else if(formData.NAME != null && formData.NAME != undefined){
          if(formData.NAME.trim().length==0){
            formData.NAME="";
            $("#NAME").addClass("ng-touched ng-invalid validate-error");
            $("#NAME").removeClass("ng-untouched ng-valid");
            message += "Please enter Organization Name <br/>";
            isValid = false;
          }
       }
        else {
          $("#NAME").addClass("ng-untouched ng-valid");
          $("#NAME").removeClass("ng-touched ng-invalid validate-error");
        }
      }
      if (formData.LICENCE_END_DATE === null || formData.LICENCE_END_DATE === "") {
        $("#LICENCE_END_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#LICENCE_END_DATE").removeClass("ng-untouched ng-valid");

        $("#lblLICENCE_END_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#lblLICENCE_END_DATE").removeClass("ng-untouched ng-valid");

        message += "Please select Application Validity <br/>";
        isValid = false;
      }
       else 
       {
        const ldate = new Date(formData.LICENCE_END_DATE);
        let tdate = new Date();
        tdate.setHours(0, 0, 0, 0);
        tdate.setDate(tdate.getDate());
        if (ldate < tdate && formData.RECORD_STATE == 0) {
          $("#LICENCE_END_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#LICENCE_END_DATE").removeClass("ng-untouched ng-valid");
          $("#lblLICENCE_END_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#lblLICENCE_END_DATE").removeClass("ng-untouched ng-valid");
          message += "Organization cannot be set to active as validity is expired <br/>";
          isValid = false;
        }
        else {
          $("#LICENCE_END_DATE").addClass("ng-untouched ng-valid");
          $("#LICENCE_END_DATE").removeClass("ng-touched ng-invalid validate-error");
          $("#lblLICENCE_END_DATE").addClass("ng-untouched ng-valid");
          $("#lblLICENCE_END_DATE").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (formData.ACTIVE_USERS_LIMIT === null || formData.ACTIVE_USERS_LIMIT === "" || formData.ACTIVE_USERS_LIMIT === undefined || formData.ACTIVE_USERS_LIMIT < 1) {
        $("#ACTIVE_USERS_LIMIT").addClass("ng-touched ng-invalid validate-error");
        $("#ACTIVE_USERS_LIMIT").removeClass("ng-untouched ng-valid");
        message += "Please enter Number of Active Accounts <br/>";
        isValid = false;
      }
      else if (isNaN(formData.ACTIVE_USERS_LIMIT)) {
        $("#ACTIVE_USERS_LIMIT").addClass("ng-touched ng-invalid validate-error");
        $("#ACTIVE_USERS_LIMIT").removeClass("ng-untouched ng-valid");
        message += "Please enter valid Number of Active Accounts <br/>";
        isValid = false;
      } else {
        if (Number(formData.ACTIVE_USERS_LIMIT) > 9999) {
          $("#ACTIVE_USERS_LIMIT").addClass("ng-touched ng-invalid validate-error");
          $("#ACTIVE_USERS_LIMIT").removeClass("ng-untouched ng-valid");
          message += "Maximum Number of Active Accounts Limit is 9999 <br/>";
          isValid = false;
        }
        else if (Number(formData.ACTIVE_USERS_LIMIT) < Number(this.UserCnt)) {
          $("#ACTIVE_USERS_LIMIT").addClass("ng-touched ng-invalid validate-error");
          $("#ACTIVE_USERS_LIMIT").removeClass("ng-untouched ng-valid");
          message += "The active user count has already reached to " + Number(this.UserCnt) + ". Kindly enter the value more than " + Number(this.UserCnt) + "<br/>";
          isValid = false;
        }
        else if (Number(formData.ACTIVE_USERS_LIMIT) < 1) {
          $("#ACTIVE_USERS_LIMIT").addClass("ng-touched ng-invalid validate-error");
          $("#ACTIVE_USERS_LIMIT").removeClass("ng-untouched ng-valid");
          message += "Invalid Number of Active Accounts Limit <br/>";
          isValid = false;
        }
        else {
          $("#ACTIVE_USERS_LIMIT").addClass("ng-untouched ng-valid");
          $("#ACTIVE_USERS_LIMIT").removeClass("ng-touched ng-invalid validate-error");
        }
      }
      if ((formData.IST == null || formData.IST == "") && (formData.EAP == null || formData.EAP == "") && (formData.GRANTS == null || formData.GRANTS == "")) {
        $("#IST").addClass("ng-touched ng-invalid validate-error");
        $("#IST").removeClass("ng-untouched ng-valid");
        message += "Please enable at least one Program <br/>";
        isValid = false;
      }

      if(formData.IS_ANALYTICS_CONFIGURED  == true){
        if(formData.LOGI_URL == null || formData.LOGI_URL == ""){
          $("#LOGI_URL").addClass("ng-touched ng-invalid validate-error");
          $("#LOGI_URL").removeClass("ng-untouched ng-valid");
          message += "Please enter URL <br/>";
          isValid = false;
        }
        if(formData.LOGI_CLIENTID == null || formData.LOGI_CLIENTID == ""){
          $("#LOGI_CLIENTID").addClass("ng-touched ng-invalid validate-error");
          $("#LOGI_CLIENTID").removeClass("ng-untouched ng-valid");
          message += "Please enter Client ID <br/>";
          isValid = false;
        }
        if(formData.LOGI_CLIENT_SECRET == null || formData.LOGI_CLIENT_SECRET == ""){
          $("#LOGI_CLIENT_SECRET").addClass("ng-touched ng-invalid validate-error");
          $("#LOGI_CLIENT_SECRET").removeClass("ng-untouched ng-valid");
          message += "Please enter Client Secret ID <br/>";
          isValid = false;
        }
        if(formData.LOGI_SUPERVISOR_USERNAME == null || formData.LOGI_SUPERVISOR_USERNAME == ""){
          $("#LOGI_SUPERVISOR_USERNAME").addClass("ng-touched ng-invalid validate-error");
          $("#LOGI_SUPERVISOR_USERNAME").removeClass("ng-untouched ng-valid");
          message += "Please enter Supervisor UserName <br/>";
          isValid = false;
        }
        if(formData.LOGI_SUPERVISOR_PASSWORD == null || formData.LOGI_SUPERVISOR_PASSWORD == ""){
          $("#LOGI_SUPERVISOR_PASSWORD").addClass("ng-touched ng-invalid validate-error");
          $("#LOGI_SUPERVISOR_PASSWORD").removeClass("ng-untouched ng-valid");
          message += "Please enter Supervisor Password <br/>";
          isValid = false;
        }
      }
      if (!(formData.CODE === null || formData.CODE === "" || formData.CODE === undefined))
     {
      if (formData.CODE.trim().length < 4 ) {
        $("#NAME").addClass("ng-touched ng-invalid validate-error");
        $("#NAME").removeClass("ng-untouched ng-valid");
        message += "Organization Code must have at least 4 characters <br/>";
        isValid = false;
      }
    }
    if(!(formData.NAME === null || formData.NAME === "" || formData.NAME === undefined)){
      if(formData.NAME.trim().length < 4){
        $("#NAME").addClass("ng-touched ng-invalid validate-error");
        $("#NAME").removeClass("ng-untouched ng-valid");
        message += "Organization Name must have at least 4 characters <br/>";
        isValid = false;
      }

    }

    if(formData.IST === true){

      if((formData.IST_DISPLAY_NAME === null || formData.IST_DISPLAY_NAME === "" || formData.IST_DISPLAY_NAME === undefined)){
        $("#IST_DISPLAY_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#IST_DISPLAY_NAME").removeClass("ng-untouched ng-valid");
        message += "Please enter IST Display Name <br/>";
        isValid = false;
      } 
      else if(formData.IST_DISPLAY_NAME !== null && formData.IST_DISPLAY_NAME.trim() === ""){
          $("#IST_DISPLAY_NAME").addClass("ng-touched ng-invalid validate-error");
          $("#IST_DISPLAY_NAME").removeClass("ng-untouched ng-valid");
          message += "Please enter IST Display Name <br/>";
          isValid = false;
      }
      else {
        $("#IST_DISPLAY_NAME").addClass("ng-untouched ng-valid");
        $("#IST_DISPLAY_NAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }
  
    if(formData.GRANTS === true){
  
      if((formData.GRANTS_DISPLAY_NAME === null || formData.GRANTS_DISPLAY_NAME === "" || formData.GRANTS_DISPLAY_NAME === undefined)){
        $("#GRANTS_DISPLAY_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#GRANTS_DISPLAY_NAME").removeClass("ng-untouched ng-valid");
  
        message += "Please enter Grants Display Name <br/>";
        isValid = false;
      } 

      else if(formData.GRANTS_DISPLAY_NAME !== null && formData.GRANTS_DISPLAY_NAME.trim() === ""){
        $("#GRANTS_DISPLAY_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#GRANTS_DISPLAY_NAME").removeClass("ng-untouched ng-valid");
  
        message += "Please enter Grants Display Name <br/>";
        isValid = false;
      }
  
      if((formData.CME_DISPLAY_NAME === null || formData.CME_DISPLAY_NAME === "" || formData.CME_DISPLAY_NAME.trim() === undefined)){
          $("#CME_DISPLAY_NAME").addClass("ng-touched ng-invalid validate-error");
          $("#CME_DISPLAY_NAME").removeClass("ng-untouched ng-valid");
          message += "Please enter Continuing Medical Education Display Name <br/>";
          isValid = false;
      }
      else if(formData.CME_DISPLAY_NAME !== null && formData.CME_DISPLAY_NAME.trim() === ""){
        $("#CME_DISPLAY_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#CME_DISPLAY_NAME").removeClass("ng-untouched ng-valid");
        message += "Please enter Continuing Medical Education Display Name <br/>";
        isValid = false;
      }
       if((formData.CHARITY_DISPLAY_NAME.trim() === null || formData.CHARITY_DISPLAY_NAME.trim() === "" || formData.CHARITY_DISPLAY_NAME.trim() === undefined)){
          $("#CHARITY_DISPLAY_NAME").addClass("ng-touched ng-invalid validate-error");
          $("#CHARITY_DISPLAY_NAME").removeClass("ng-untouched ng-valid");
          message += "Please enter Charitable Display Name <br/>";
          isValid = false;
      }
      else if(formData.CHARITY_DISPLAY_NAME !== null && formData.CHARITY_DISPLAY_NAME.trim() === ""){
        $("#CHARITY_DISPLAY_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#CHARITY_DISPLAY_NAME").removeClass("ng-untouched ng-valid");
        message += "Please enter Charitable Display Name <br/>";
        isValid = false;
      }
       if((formData.SPONSERSHIP_DISPLAY_NAME.trim() === null || formData.SPONSERSHIP_DISPLAY_NAME.trim() === "" || formData.SPONSERSHIP_DISPLAY_NAME.trim() === undefined)){
        $("#SPONSERSHIP_DISPLAY_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#SPONSERSHIP_DISPLAY_NAME").removeClass("ng-untouched ng-valid");
        message += "Please enter Sponsorship Display Name <br/>";
        isValid = false;
    }
    else if(formData.SPONSERSHIP_DISPLAY_NAME !== null && formData.SPONSERSHIP_DISPLAY_NAME.trim() === ""){
      $("#SPONSERSHIP_DISPLAY_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#SPONSERSHIP_DISPLAY_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Sponsorship Display Name <br/>";
      isValid = false;
    }
  
      else {
        $("#GRANTS_DISPLAY_NAME").addClass("ng-untouched ng-valid");
        $("#GRANTS_DISPLAY_NAME").removeClass("ng-touched ng-invalid validate-error");
  
        $("#CME_DISPLAY_NAME").addClass("ng-untouched ng-valid");
        $("#CME_DISPLAY_NAME").removeClass("ng-touched ng-invalid validate-error");
  
        $("#CHARITY_DISPLAY_NAME").addClass("ng-untouched ng-valid");
        $("#CHARITY_DISPLAY_NAME").removeClass("ng-touched ng-invalid validate-error");
  
        $("#SPONSERSHIP_DISPLAY_NAME").addClass("ng-untouched ng-valid");
        $("#SPONSERSHIP_DISPLAY_NAME").removeClass("ng-touched ng-invalid validate-error");
      }
      

    }
    

    if(formData.IST_DISPLAY_NAME !="" &&formData.IST_DISPLAY_NAME!=undefined && formData.IST_DISPLAY_NAME!=null){
      this.displayNames.push(formData.IST_DISPLAY_NAME.toLowerCase().trim());
     }
  
      if(this.displayNames.indexOf(formData.EAP_DISPLAY_NAME.toLowerCase().trim())>-1)
        {
        isvalidMsg=false;
      }
      else{
        if(formData.EAP_DISPLAY_NAME!=""&&formData.EAP_DISPLAY_NAME!=undefined&&formData.EAP_DISPLAY_NAME!=null)
        this.displayNames.push(formData.EAP_DISPLAY_NAME.toLowerCase().trim());
      }
  
      if(this.displayNames.indexOf(formData.GRANTS_DISPLAY_NAME.toLowerCase().trim())>-1){
        isvalidMsg=false;
      }
      else{
        if(formData.GRANTS_DISPLAY_NAME!=""&&formData.GRANTS_DISPLAY_NAME!=undefined&&formData.GRANTS_DISPLAY_NAME!=null)
        this.displayNames.push(formData.GRANTS_DISPLAY_NAME.toLowerCase().trim());
      }
  
      if(this.displayNames.indexOf(formData.CME_DISPLAY_NAME.toLowerCase().trim())>-1){
        isvalidMsg=false;
      }
      else{
        if(formData.CME_DISPLAY_NAME!=""&&formData.CME_DISPLAY_NAME!=undefined&&formData.CME_DISPLAY_NAME!=null)
        this.displayNames.push(formData.CME_DISPLAY_NAME.toLowerCase().trim());
      }
  
      if(this.displayNames.indexOf(formData.CHARITY_DISPLAY_NAME.toLowerCase().trim())>-1){
        isvalidMsg=false;
      }
      else{
        if(formData.CHARITY_DISPLAY_NAME!=""&&formData.CHARITY_DISPLAY_NAME!=undefined&&formData.CHARITY_DISPLAY_NAME!=null)
        this.displayNames.push(formData.CHARITY_DISPLAY_NAME.toLowerCase().trim());
      }
  
      if(this.displayNames.indexOf(formData.SPONSERSHIP_DISPLAY_NAME.toLowerCase().trim())>-1){
        isvalidMsg=false;
      }
      else{
        if(formData.SPONSERSHIP_DISPLAY_NAME!=""&&formData.SPONSERSHIP_DISPLAY_NAME!=undefined&&formData.SPONSERSHIP_DISPLAY_NAME!=null)
        this.displayNames.push(formData.SPONSERSHIP_DISPLAY_NAME.toLowerCase().trim());
      }

    if(!isvalidMsg){
      message += "Please enter Unique Display Name <br/>";
      isValid = false;
    }

    }
    else {
      // If IST module select, ISt Currency selection is mandatory
      if (formData.IST !== null && formData.IST !== "") {
        if (Boolean(formData.IST)) {
          if (formData.IST_CURRENCY_ID === null || formData.IST_CURRENCY_ID === "" || formData.IST_CURRENCY_ID === undefined) {
            $("#IST_CURRENCY_ID").addClass("ng-touched ng-invalid validate-error");
            $("#IST_CURRENCY_ID").removeClass("ng-untouched ng-valid");
            message += "Please select IST Currency <br/>";
            isValid = false;
          } else {
            $("#IST_CURRENCY_ID").addClass("ng-untouched ng-valid");
            $("#IST_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
          }
        } else {
          $("#IST_CURRENCY_ID").addClass("ng-untouched ng-valid");
          $("#IST_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
        }
      }
      else {
        $("#IST_CURRENCY_ID").addClass("ng-untouched ng-valid");
        $("#IST_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
      }


      if (formData.EAP !== null && formData.EAP !== "") {
        if (Boolean(formData.EAP)) {
          if (formData.EAP_CURRENCY_ID === null || formData.EAP_CURRENCY_ID === "" || formData.EAP_CURRENCY_ID === undefined) {
            $("#EAP_CURRENCY_ID").addClass("ng-touched ng-invalid validate-error");
            $("#EAP_CURRENCY_ID").removeClass("ng-untouched ng-valid");
            message += "Please select EAP Currency <br/>";
            isValid = false;
          } else {
            $("#EAP_CURRENCY_ID").addClass("ng-untouched ng-valid");
            $("#EAP_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
          }
        } else {
          $("#EAP_CURRENCY_ID").addClass("ng-untouched ng-valid");
          $("#EAP_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
        }
      }
      else {
        $("#EAP_CURRENCY_ID").addClass("ng-untouched ng-valid");
        $("#EAP_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
      }

      if (formData.GRANTS !== null && formData.GRANTS !== "") {
        if (Boolean(formData.GRANTS)) {
          if (Boolean(formData.GRANTS)) {
            if ((formData.CME == null || formData.CME == "") 
                &&(formData.CHARITY == null || formData.CHARITY == "") 
                && (formData.SPONSERSHIP == null || formData.SPONSERSHIP == "")) 
            {
              message +=
                "Selection of atleast one Grant type is mandatory to save the detail <br/>";
              isValid = false;
            } 
          }
          else
          {
            if (formData.CME !== null && formData.CME !== "") {
              if (Boolean(formData.CME)) {
                if (
                  formData.CME_CURRENCY_ID === null ||
                  formData.CME_CURRENCY_ID === "" ||
                  formData.CME_CURRENCY_ID === undefined
                ) {
                  $("#CME_CURRENCY_ID").addClass(
                    "ng-touched ng-invalid validate-error"
                  );
                  $("#CME_CURRENCY_ID").removeClass(
                    "ng-untouched ng-valid"
                  );
                  message += "Please select CME Currency <br/>";
                  isValid = false;
                } else {
                  $("#CME_CURRENCY_ID").addClass("ng-untouched ng-valid");
                  $("#CME_CURRENCY_ID").removeClass(
                    "ng-touched ng-invalid validate-error"
                  );
                }
              }
            }
            if (formData.CHARITY !== null && formData.CHARITY !== "") {
              if (Boolean(formData.CHARITY)) {
                if (
                  formData.CHARITABLE_CURRENCY_ID === null ||
                  formData.CHARITABLE_CURRENCY_ID === "" ||
                  formData.CHARITABLE_CURRENCY_ID === undefined
                ) {
                  $("#CHARITABLE_CURRENCY_ID").addClass(
                    "ng-touched ng-invalid validate-error"
                  );
                  $("#CHARITABLE_CURRENCY_ID").removeClass(
                    "ng-untouched ng-valid"
                  );
                  message += "Please select Charitable Currency <br/>";
                  isValid = false;
                } else {
                  $("#CHARITABLE_CURRENCY_ID").addClass("ng-untouched ng-valid");
                  $("#CHARITABLE_CURRENCY_ID").removeClass(
                    "ng-touched ng-invalid validate-error"
                  );
                }
              }
            }
            if (formData.SPONSERSHIP !== null && formData.SPONSERSHIP !== "") {
              if (Boolean(formData.SPONSERSHIP)) {
                if (
                  formData.SPONSERSHIP_CURRENCY_ID === null ||
                  formData.SPONSERSHIP_CURRENCY_ID === "" ||
                  formData.SPONSERSHIP_CURRENCY_ID === undefined
                ) {
                  $("#SPONSERSHIP_CURRENCY_ID").addClass(
                    "ng-touched ng-invalid validate-error"
                  );
                  $("#SPONSERSHIP_CURRENCY_ID").removeClass(
                    "ng-untouched ng-valid"
                  );
                  message += "Please select Sponsorship Currency <br/>";
                  isValid = false;
                } else {
                  $("#SPONSERSHIP_CURRENCY_ID").addClass("ng-untouched ng-valid");
                  $("#SPONSERSHIP_CURRENCY_ID").removeClass(
                    "ng-touched ng-invalid validate-error"
                  );
                }
              }
            }
          }



        } 
        else {
          $("#CME_CURRENCY_ID").addClass("ng-untouched ng-valid");
          $("#CME_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
          $("#CHARITABLE_CURRENCY_ID").addClass("ng-untouched ng-valid");
          $("#CHARITABLE_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
          $("#SPONSERSHIP_CURRENCY_ID").addClass("ng-untouched ng-valid");
          $("#SPONSERSHIP_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
        }
      }
      else {
        $("#CME_CURRENCY_ID").addClass("ng-untouched ng-valid");
        $("#CME_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
        $("#CHARITABLE_CURRENCY_ID").addClass("ng-untouched ng-valid");
        $("#CHARITABLE_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
        $("#SPONSERSHIP_CURRENCY_ID").addClass("ng-untouched ng-valid");
        $("#SPONSERSHIP_CURRENCY_ID").removeClass("ng-touched ng-invalid validate-error");
      }
      if (formData.ACC_ACTIVITY === null || formData.ACC_ACTIVITY === "" || formData.ACC_ACTIVITY === undefined) {
        $("#ACC_ACTIVITY").addClass("ng-touched ng-invalid validate-error");
        $("#ACC_ACTIVITY").removeClass("ng-untouched ng-valid");
        message += "Please select Account Activities Email <br/>";
        isValid = false;
      } else {
        $("#ACC_ACTIVITY").addClass("ng-untouched ng-valid");
        $("#ACC_ACTIVITY").removeClass("ng-touched ng-invalid validate-error");
      }
      if (formData.CORR_ACTIVITY === null || formData.CORR_ACTIVITY === "" || formData.CORR_ACTIVITY === undefined) {
        $("#CORR_ACTIVITY").addClass("ng-touched ng-invalid validate-error");
        $("#CORR_ACTIVITY").removeClass("ng-untouched ng-valid");
        message += "Please select Correspondence Email <br/>";
        isValid = false;
      } else {
        $("#CORR_ACTIVITY").addClass("ng-untouched ng-valid");
        $("#CORR_ACTIVITY").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    if (!isValid)
      this.commonservice.ValidationBanner(message);
    return isValid;
  }
  

   

  DeleteLogo(): void {
    this.url = null;
    this.document_attach_list = [];
  }

  copyUrl() {
    if (this.orgForm.controls['CODE'].value.length > 0) {
      this.Clipboard.copy(this.baseU + '/' + this.orgForm.controls['CODE'].value + '/login');
    }
  }

  DeleteUpload(file): void {

    if (file.Status == "Add") {
      let code = file.ID;
      this.document_attach_list = this.document_attach_list.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.summaryService.Delete("api/ISTFileAttachments/DeleteFile?FileID=" + file.ID).subscribe(result => {
        let code = file.ID;
        this.document_attach_list = this.document_attach_list.filter(function (sec) {
          return sec.ID != code;
        }, code);

      });
    }
  }

  Sponsorshipchange() {
    this.organization.SPONSERSHIP = !this.organization.SPONSERSHIP;
    }

  CMEchange() {
    this.organization.CME = !this.organization.CME;
  }
  Charitychange() {
        this.organization.CHARITY = !this.organization.CHARITY;
  }

}
